import { Mail } from "lucide-react";
import { initials } from "src/utils";
import { useFetchAssignedEmployee } from "../hooks/useFetchAssignedEmployee";
import { Puff } from "react-loader-spinner";

export function AssignedEmployee({ customerId }: { customerId: number }) {
  const { employee, isLoading } = useFetchAssignedEmployee(customerId);

  if (isLoading) {
    return (
      <div className="w-full flex items-center justify-center p-8">
        <Puff
          visible={true}
          height="80"
          width="80"
          color="#2c5689"
          ariaLabel="puff-loading"
          wrapperStyle={{}}
          wrapperClass=""
        />
      </div>
    );
  }

  return (
    <div className="flex items-center gap-3 rounded-xl border border-border/70 bg-background/40 p-3">
      {employee ? (
        <>
          <div className="flex size-10 items-center justify-center rounded-full bg-blue-50 text-sm font-semibold text-accent-foreground">
            {initials(employee.full_name)}
          </div>
          <div className="min-w-0">
            <p className="truncate text-sm font-medium capitalize">
              {employee.full_name}
            </p>
            <p className="mt-0.5 flex items-center gap-1.5 truncate text-xs text-muted-foreground">
              <Mail className="size-3" />
              {employee.email}
            </p>
          </div>
          <span className="ml-auto shrink-0 rounded-full bg-secondary px-2.5 py-1 text-[11px] font-medium text-secondary-foreground">
            {employee.role}
          </span>
        </>
      ) : (
        <p className="text-sm text-muted">
          No Employee is Assigned to this customer
        </p>
      )}
    </div>
  );
}
